module.exports = "/assets/career/team/kasia.png?IHC5jbM";